import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

/**
 * Staff Attendance Analytics — Owner
 * GET /staff-attendance/analytics?period=&roleId=
 */
export const getStaffAttendanceAnalytics = async (params = {}) => {
  const res = await axiosInstance.get("/staff-attendance/analytics", {
    params,
  });
  return res.data;
};

/**
 * Staff Attendance Analytics — Portal
 * GET /staff-attendance-portal/analytics?period=&roleId=
 */
export const getStaffAttendanceAnalyticsPortal = async (params = {}) => {
  const res = await axiosInstance.get("/staff-attendance-portal/analytics", {
    params,
  });
  return res.data;
};
